export default __webpack_public_path__ + "static/media/(34).45d2061d.jpg";